import styled from 'styled-components';

export const FooterLabel = styled.p`
  text-align: center;
  margin: 35px 0px;
`;

export const VLabel = styled.span`
  ${(props) =>
    props.critical &&
    `
    color: #ff0000;
    text-weight: bold;
  `}
`;



// WEBPACK FOOTER //
// ./resources/assets/js/components/SeepageSection/style.js